import React from "react";

class Iframe extends React.Component {
	state = {
		id: this.props.id
	};

	componentDidMount() {
		this.state.id &&
			fetch(
				`https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.state
					.id}&byline=false&portrait=false&title=false&xhtml=true&autoplay=false`
			)
				.then((resp) => resp.json())
				.then((data) => {
					this.setState({
						video: data
					});
				});
	}

	render() {
		const vimeo = this.state.video;
		vimeo && vimeo.html.replace(/'frameborder'/gi, "frameBorder");
		console.log(vimeo && vimeo);
		const getAttrs = (iframeTag) => {
			var doc = document.createElement("div");
			doc.innerHTML = iframeTag;

			const iframe = doc.getElementsByTagName("iframe")[0];
			return [].slice.call(iframe.attributes).reduce((attrs, element) => {
				attrs[element.name] = element.value;
				return attrs;
			}, {});
		};

		const changeAttributes = (obj) => {
			const delProp = (propNew, propOld) => {
				Object.defineProperty(obj, propNew, Object.getOwnPropertyDescriptor(obj, propOld));
				delete obj[propOld];
			};
			Object.keys(obj).map((key) => {
				switch (key) {
					case "frameborder":
						return delProp("frameBorder", "frameborder");
					case "allowfullscreen":
						return delProp("allowFullScreen", "allowfullscreen");
					default:
						return key;
				}
			});
			return obj;
		};

		if (this.props.thumbnail) {
			return vimeo && <img src={vimeo.thumbnail_url_with_play_button} alt="" />;
		} else {
			return (
				<div className="vimeo-video">
					<div
						style={{
							display: "block",
							minHeight: "1px",
							width: "100%",

							overflow: "auto",
							padding: "56.25% 0 0 0",
							position: "relative"
						}}>
						{vimeo && (
							<iframe
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%"
								}}
								title="vimeo"
								{...changeAttributes(getAttrs(vimeo.html))}
							/>
						)}
					</div>
				</div>
			);
		}
	}
}

export default Iframe;
